import UpdateCustomer from "../../../../components/@groups/customers/UpdateCustomer";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function CustomerGroupUpdatePage() {

    return (
        <UpdateCustomer 
            routeType={routeTypes.admin}
        />
    )
}       